import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  public toasts = new BehaviorSubject<Array<any>>([]);
  hasToasts = new Subject<boolean>();

  constructor(private translate: TranslateService) {}

  showToast(text: any, type: any, options: any = {}) {
    if (typeof text === 'object') {
      this.translateAndShow(text, type, options);
    } else if (typeof text === 'string' && text.indexOf('lang') > -1) {
      if (!options) {
        options = {};
      }

      if (options.clearToasts) {
        this.clearAllToasts();
      }

      if (type === 'toastError' || type === 'toastWarning') {
        if (!options.delay) {
          options.delay = '15000'; // default delay for toasts unless specified
        }
      }

      this.translate.get(text).subscribe((resMessage: string) => {
        this.showToast(resMessage, type, options);
      });
    } else {
      if (!options) {
        options = {};
      }

      if (options.clearToasts) {
        this.clearAllToasts();
      }

      if (type === 'toastError') {
        if (!options.delay) {
          options.delay = '15000'; // default delay for toasts unless specified
        }
      }
      if (Object.keys({ text, type, ...options }).length > 0) {
        this.toasts.next([...this.toasts.getValue(), { text, type, ...options }]);
        this.hasToasts.next(true);
      }
    }
  }

  removeToast(toast: any) {
    this.toasts.next([...this.toasts.getValue().filter(t => t !== toast)]);
    if (this.toasts.getValue().length === 0) {
      this.hasToasts.next(false);
    }
  }

  clearAllToasts() {
    this.toasts.next([...this.toasts.getValue().filter(t => t.dontRemoveOnRouteChange === true)]);
    this.hasToasts.next(false);
  }

  hasOpenToasts() {
    return this.toasts.getValue().length > 0;
  }

  private translateAndShow(text: string[], type: any, options: any) {
    if (text.length > 0) {
      this.translate.get(text).subscribe((resMessage: string) => {
        console.log(resMessage);
        const toastMessage: string[] = [];
        Object.keys(resMessage).forEach((item, k) => {
          toastMessage.push(resMessage[item]);
        });
        this.showToast(toastMessage.join(' '), type, options);
      });
    }
  }
}
